<template>
    <div class="p-3">
        <b-card title="Pengaturan Pengumuman">
            <b-card-text>
                <b-button variant="primary" class="btn-sm" @click="addPengumuman"><b-icon icon="plus"></b-icon> Tambah Data</b-button>

                <div class="mt-3" id="table-pengumuman"></div>
            </b-card-text>
        </b-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            pengumuman: []
        }
    },
    created() {
        this.getPengumuman()
    },
    methods: {
        getPengumuman() {
            this.$isLoading(true)
            let uri = '/api/pengumuman'

            this.axios.get(uri).then(response => {
                if (response.data.status == 'success') {
                    this.pengumuman = response.data.pengumuman

                    let status = function (cell, formatterParams) {
                        let data = cell.getRow().getData()

                        return data.PengumumanStatus == 1 ? 'Aktif' : 'Tidak Aktif'
                    }

                    let actions = function (cell, formatterParams) {
                        return '<button id="edit" class="btn btn-warning btn-sm"><i id="edit" class="fa fa-pencil" aria-hidden="true"></i></button>&nbsp;&nbsp;<button id="delete" class="btn btn-danger btn-sm"><i id="delete" class="fa fa-trash" aria-hidden="true"></i></button>'
                    }

                    let table = new Tabulator('#table-pengumuman', {
                        data: this.pengumuman,
                        layout: "fitColumns",
                        columns: [
                            { title: 'ID', field: 'PengumumanID', maxWidth: 100 },
                            { title: 'Judul', field: 'PengumumanJudul', maxWidth: 250 },
                            { title: 'Isi', field: 'PengumumanIsi', minWidth: 500 },
                            { title: 'Status', formatter: status, maxWidth: 100 },
                            { title: 'Dibuat Tanggal', field: 'PengumumanCreateDate', minWidth: 150 },
                            { title: 'Aksi', formatter: actions, maxWidth: 100, cellClick: this.actionButton }
                        ]
                    })
                }
                
                this.$isLoading(false)
            })
        },
        addPengumuman() {
            this.$router.push({ name: 'add-pengumuman' }).catch(() => { })
        },
        actionButton(e, cell) {
            let data = cell.getRow().getData()
            let type = e.target.id
            if (type == 'edit') {
                this.$router.push({ name: 'edit-pengumuman', params: { id: data.PengumumanID } }).catch(() => { })
            } else if (type == 'delete') {
                this.$swal.fire({
                    title: 'Perhatian! ',
                    text: 'Data akan dihapus. Yakin?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ya, hapus!',
                    cancelButtonText: 'Batal'
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.deletePengumuman(data.PengumumanID)
                    }
                })
            }
        },
        deletePengumuman(id) {
            this.$isLoading(true)
            let uri = '/api/pengumuman/' + id

            this.axios.delete(uri).then(response => {
                if (response.data.status == 'success') {
                    this.getPengumuman()
                } else {
                    this.$isLoading(false)
                    this.$swal.fire({
                        title: 'Error!',
                        text: response.data.message,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                }
            })
        },
    }
}
</script>